import React from 'react';
import './Copyright.css';

// Shared copyright line: app footer and login pages (desktop + mobile).
// Year is computed so it never goes stale.
function Copyright({ showNotice = false, className = '' }) {
  return (
    <div className={`copyright ${className}`}>
      <div>&copy; {new Date().getFullYear()} Maranatha Broadcasting / WFMZ-TV. All rights reserved.</div>
      {showNotice && (
        <div className="copyright-notice">For use by authorized WFMZ-TV staff only.</div>
      )}
    </div>
  );
}

export default Copyright;
